import React, { Component } from 'react';
import { TextField, TextFieldIcon, TextFieldHelperText } from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Card } from 'rmwc/Card';
import { Link } from 'react-router-dom'
import SerializeForm from 'form-serialize';
import * as api from '../../api/api';
import { Grid, GridCell } from 'rmwc/Grid';
import { Radio, Checkbox } from 'rmwc/Radio';
import { connect } from 'react-redux'
import PlacesAutoComplete from 'react-places-autocomplete'

import * as actions from '../../actions'
import GooglePlacesAutoComplete from '../GooglePlacesAutoComplete'
import StatusMessage from '../../util/StatusMessage'
import ReactGA from 'react-ga';



class CentaTQRegistration extends Component{

  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',
      tpoRefOther: false,
      genOtpCount: 0,
      partialPersonalFirstSave: 'not_started',
      currentDate: '',
      srcOfReg: '',
      partialLoader: false,
      confirmOTPLoader: false,
      'tqUrl': '',
      'tpoUrl': '',
      data:{
        'firstName': '',
        'lastName': '',
        'email': '',
        'countryCode': '91',
        'phone': '',
        'gender_id': '',
        'user_name': '',
        'password': '',
        'password_confirmation':'',
        'stateId': '',
        'countryId': '1',
        'tqTypeId': '',
        'tqType': [],
        'tqTypeName': '',
        'states': [],
        'countries': [],
        'city': '',
        'tqTestTracks': [],
        'tqTestTrackId': '',
        'tqTestDates':[],
        'tqTestDate':'',
        'tqTestDateId': '',
        'teachingAssociations': [],
        'teachingAssociationId': '',
        'teachingAssociationName': '',
        'testcenters': [],
        'testcenterId': '',
        'testCenterName': '',
        'payment_modes': [],
        'paymentModeId': 4,
        'trackAmount': 0,
        'discountValue': 0,
        'registrationFee': 0.0,
        'referralCode': '',
        'accessToken': '',
        'certification_participation_id': '',
        'regType': 'TQ',
        'examDateOption': '',
        'examDate': '',
        'dob': '',
        'initialFee': '',
        'regPhoneNumber' : '',
        'eligibility': '',
        'trackDetailMessage': '',
        'reg_eligibility': '',
        'paymentStatus': '',
        'usDollarAmount': 0.0,
        'discountedDollarValue': 0.0,
        'registrationFeeInDollar': 0.0,
        'addOnOptions': [],
        'selectedAddonOption': '',
        'isAddOnAVailableForParentTrack': '',
        'trackFeeWithoutAddon': '',
        'trackFeeInDolloarWithoutAddon': '',
        'trackFeeWithAddon':'',
        'trackFeeInDolloarWithAddon':'',
        'initialFeeWithAddOn': '',
        'partialRegId': '',
        'initialTqTestTrack': '',
        'initialSelectedAddonOption': '',
        'initalAddonAvailableforParentTrack': '',
        'tqId': '',
        'timeSlots': [],
        'timeSlot': '',
      },
      componentState:{
        first_disable:false,
        last_disable:false,
      },
      saveState:{
        saveDisabled: true
      },

      formErrors:{
        'firstNameError':'',
        'lastNameError':'',
        'emailError': '',
        'cityOfResidenceError':'',
        'countryIdError':'',
        'stateIdError':'',
        'teachingAssociationIdError':'',
        'workingOrganizationError':'',
        'testCenterError': '',
        'testTrackError':'',
        'testDateError': '',
        'paymentModeError':'',
        'phoneNumberError': '',
        'communicationError': '',
        'userNameError' :'',
        'passwordError': '',
        'GenderError':'',
        'passwordConfirmationError': '',
        'userNameUniqueError': '',
        'emailUniqueError': '',
        'emailFormatError': '',
        'phoneUniqueError': '',
        'userOtpError': '',
        'genOTPCountError': '',
        'userId': '',
        'role': '',
        'examDateOptionError': '',
        'examDateError': '',
        'dobError': '',
        'regPhoneNumberError': '',
        'tqTestTrackError': '',
        'discountCouponError': '',
        'eligibiltyError': '',
        'regEligibilityError': '',
        'certificateNameError': '',
        'timeSlotError': ''
      },

      disableState: {
        awaitingConf: true,
        genOtpState: false,
        disablePhone: true,
        discountDisable: true,
        disableConfirmRegen: false,
        regEligibilityHidden: true,
        disableFieldsOnLoader: true,
        examDateDisabled: false,
      },

      regOtp: {
        userId: '',
        userType: '',
        otpCode: '',
        otpState: 'initial',
        userActivated: false,
        phoneType: ''       
      }

    };

  }

  componentDidMount(){
    ReactGA.set({ userId: 1 });
    ReactGA.initialize('UA-124053817-1');
    ReactGA.pageview('/centa_tq_registration');
    let data = Object.assign({}, this.state.data) 
    let  currentTime = new Date()
    let m = currentTime.getMonth() + 1
    let d = currentTime.getDate()
    let y = currentTime.getFullYear()
    let currentDate = y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d)
    api.getCountries('')
    .then((result) => {
      data.countries = result
      this.setState({currentDate: currentDate, data: data})
    })
  }

  handletqTypeChange = (event) => {
    var index = event.target.selectedIndex;
    var optionElement = event.target.childNodes[index]
    let data = Object.assign({}, this.state.data)
    data.tqTypeId = event.target.value
    data.tqTypeName = optionElement.getAttribute('data-name')
    this.setState({data: data})
  }

  handleCountriesChange = (event) =>{
    var data = Object.assign({},this.state.data)
    data.countryId = event.target.value
    if((data.countryId === '1') || (data.countryId === 1)){
      data.countryCode = '91'
    }
    else{
      data.countryCode = ''
    }
    this.setState({data: data})
  }  

  /*#Outide Form State,City is disbaled.Counties will used ly at the begining of the form
  --handleCountriesChange = (event) =>{  
    var index = event.target.selectedIndex;
    var optionElement = event.target.childNodes[index]
    let data = Object.assign({}, this.state.data)
    let countryChanged = true
    data.countryId = event.target.value
    data.countryName = optionElement.getAttribute('data-name')

    if (countryChanged) {
      api.getStates('', data.countryId)
      .then((states) => {
        data.states = states
        data.stateId = ''
        this.setState({data: data})
      })
    } else {
      this.setState({data: data})
    }
  }

  handleStatesChange = (event) =>{
    let data = Object.assign({}, this.state.data)
    if(event.target.value){
      let selectedOption = event.target.value
      data.stateId = selectedOption
    }
    else{
      data.stateId = ''
    }
    this.setState({data: data})
  }


  handleCityChange = (value) =>{
    let data = Object.assign({}, this.state.data)
    data.city = value
    this.setState({data: data})
  }

  handleCitySelect = (address) => {
    let data = Object.assign({}, this.state.data)
    data.city = address
    this.setState({data: data})
  }*/

  handleSchoolChange =(value) => {
    let data = Object.assign({}, this.state.data)
    data.workingOrganization = value
    this.setState({data: data})    
  }

  handleSchoolSelect = (value) => {
    let data = Object.assign({}, this.state.data)
    data.workingOrganization = value
    this.setState({data: data})
  }

  handleTeachingAssociationSelection = (event) =>{
        
    let data = Object.assign({}, this.state.data)
      data.teachingAssociationIdOther=''
      data.workingPositionId = ''
      data.workingPositionName =''
      data.workingOrganization=''
    if(event.target.value){
      let selectedOption = event.target.value
      var index = event.target.selectedIndex;
      var optionElement = event.target.childNodes[index]
      data.teachingAssociationId = selectedOption
      data.teachingAssociationName = optionElement.getAttribute('data-name')
    }
    else{
      data.teachingAssociationId = ''
      data.teachingAssociationName = ''
      
    }
    if(!data.certification_participation_id){
      this.handleCreateUpdatePartialSave('teachingAssociation', data)
    }
    else{
      this.setState({data: data})
    }
  }

 // Test Center as option is removed from the form. To be added on later if required, 
//reason - the exams are going to be online for now

 /* handleTestCenterChange = (event) =>{
 
    let data = Object.assign({}, this.state.data)
    let timeSlots = Object.assign({}, this.state.timeSlots)
      if(event.target.value){
        let selectedOption = event.target.value
        var index = event.target.selectedIndex;
        var optionElement = event.target.childNodes[index]

        data.testcenterId = selectedOption
        data.testCenterName = optionElement.getAttribute('data-name')

        api.getTQTestDates('', data.testcenterId)          
        .then((result) =>{
            data.tqTestDates = result
            this.setState({data: data})         
        })

      }
      else{
         data.testcenterId = ''
         data.tqTestDates =[]
         this.setState({data: data})
      }
  }
  */
  
  handleTQTestDateChange = (event) =>{
    let data = Object.assign({}, this.state.data)
    if(event.target.value){
      let selectedOption = event.target.value
      data.tqTestDateId = selectedOption
    }
    else{
      data.tqTestDateId = ''
    }
    this.setState({data: data})
  }

//on change of track the fee also should be updated so api call for track based fee
  handleTestTrackChange = (event) =>{
    
    let data = Object.assign({}, this.state.data)
    let errorObj = Object.assign({}, this.state.formErrors)
    let saveState = Object.assign({}, this.state.saveState)
    let disableState = Object.assign({}, this.state.disableState)
    disableState.examDateDisabled = false
    this.setState({errorMsg: '', disableState: disableState})
    errorObj.eligibiltyError= ''
    if(event.target.value){
      let selectedOption = event.target.value
      data.tqTestTrackId = selectedOption
      var optionElement = event.target.childNodes[event.target.selectedIndex]
      let url = `tq/check/track/eligibility/${data.tqTestTrackId}`
      let get_track_fee_url = `/fetch/tq/track/fee/${data.tqTestTrackId}`
      let getDatesUrl = `fetch/date/time/slot?type=exam_date&tq_test_track_id=${data.tqTestTrackId}`
      //on change of track the applied discount should be cleared
      data.discountValue = 0
      data.registrationFee = data.trackAmount
      data.registrationFeeInDollar = data.usDollarAmount
      if(data.referralCode !== ''){
        data.referralCode = ''
        errorObj.discountCouponError = 'Since the track is changed the referral code has to be provided once again to avail the discount.'
      }
      api.getResponse(data.accessToken, url)
      .then((result) =>{
        if(result.status === 'success'){
          data.eligibility = result.data.eligibility
          data.trackDetailMessage = result.data.track_detail
          data.paymentStatus = result.data.payment_status
          data.isAddOnAVailableForParentTrack = result.data.is_add_on_available
          //reset add on selection
          data.selectedAddonOption = ''
        }
        else if (result.status === 'error'){
          errorObj.eligibiltyError = result.message
        }
        if(data.eligibility === 'not_eligible' && (data.tqTestTrackId != data.initialTqTestTrack)){
          data.referralCode = ''
          data.isAddOnAVailableForParentTrack = ''
          errorObj.discountCouponError = ''
          saveState.saveDisabled = true
        }
        else{
          if(data.tqTestTrackId == data.initialTqTestTrack){
              data.isAddOnAVailableForParentTrack = data.initalAddonAvailableforParentTrack
              data.selectedAddonOption = data.initialSelectedAddonOption
            }
          saveState.saveDisabled = false
        }
        return api.getResponse(data.accessToken, get_track_fee_url)
        }).then((result) =>{
          if(result.status === 'success'){
            data.trackAmount = result.data.amount
            data.registrationFee = result.data.amount
            data.usDollarAmount = result.data.dollar_amount
            data.registrationFeeInDollar = result.data.dollar_amount

            // incase of addons addon should be separtely stored for display purpose
            data.trackFeeWithoutAddon = result.data.amount
            data.trackFeeInDolloarWithoutAddon = result.data.dollar_amount
            data.trackFeeWithAddon = result.data.add_on_amount
            data.trackFeeInDolloarWithAddon = result.data.add_on_dollar_amount
            data.initialFee = result.data.inital_fee
            data.initialFeeWithAddOn = result.data.inital_fee_with_add_on
          }
          //this.setState({data: data, formErrors: errorObj, saveState: saveState})
        return api.getResponse(data.accessToken, getDatesUrl)
        }).then((result) => {

        if(result.status === 'success'){
          data.tqTestDates = result.data
          data.examDate = ''
          data.timeSlots = []
          data.timeSlot = ''
        }
        else if(result.status === 'error'){
          saveState.saveDisabled = true
          data.tqTestDates = []
          data.timeSlots = []
          data.timeSlot = ''
          disableState.examDateDisabled = true
          this.setState({errorMsg: result.message, data: data, saveState: saveState, disableState: disableState})
        }  
        if(!data.certification_participation_id && !saveState.saveDisabled){
          this.handleCreateUpdatePartialSave('testTrack', data)
        }
        else{
          this.setState({data: data, formErrors: errorObj, saveState: saveState, disableState: disableState})
        }
      })
    }
  }

    // PART of TEST TRACK C
      //Change - Moving to Flat fee structure from test track based. 
      //To be brought back when the TQ moves to test track based fee structure
      //data.trackAmount = optionElement.getAttribute('track-amount')
      //data.registrationFee = data.trackAmount
    //}
    //else{
      //data.tqTestTrackId = ''
      //data.trackAmount = 0
    //}
    //this.setState({data: data})
  //}

  handlePaymentModeChange = (event) => {
    let data = Object.assign({}, this.state.data)
    data.paymentModeId = event.target.value
    this.setState({data: data})
  }

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  }

  onAddonOptionChange = (evt) => {
    let data = Object.assign({}, this.state.data)
    let errorObj = Object.assign({},this.state.formErrors)
    let valuetoSet =  parseInt(evt.target.value)
    
    //Clear discount on change of Online selection
    data.discountValue = 0
    //Set the flag for ui and change the fee based on selection
    if(data.referralCode !== ''){
      data.referralCode = ''
      errorObj.discountCouponError = 'Since the track is changed the referral code has to be provided once again to avail the discount.'
    }
    if(this.state.data.selectedAddonOption !== ''){
      data[evt.target.name] = ''
      data.registrationFee = data.trackFeeWithoutAddon
      data.trackAmount = data.trackFeeWithoutAddon
      data.usDollarAmount = data.trackFeeInDolloarWithoutAddon
      data.registrationFeeInDollar = data.trackFeeInDolloarWithoutAddon
    }
    else{
       data[evt.target.name] = valuetoSet
       data.registrationFee = data.trackFeeWithAddon
       data.trackAmount = data.trackFeeWithAddon
       data.usDollarAmount = data.trackFeeInDolloarWithAddon
       data.registrationFeeInDollar = data.trackFeeInDolloarWithAddon
    }
      
    //Reset Discount
    data.discountValue = 0
    if(!data.certification_participation_id){
      this.handleCreateUpdatePartialSave('addonOption', data)
    }
    else{
      this.setState({data: data, formErrors: errorObj})
    }
  }

  handleTQTestDateChange = (event) =>{
    this.setState({errorMsg: ''})
    let data = Object.assign({}, this.state.data)
    let saveState = Object.assign({}, this.state.saveState)
    data.examDate = event.target.value
    let testDateId = this.searchDate(data.examDate, data.tqTestDates)
    let slotUrl = `fetch/date/time/slot?type=time_slot&tq_test_track_id=${data.tqTestTrackId}&test_date_id=${testDateId}`
    api.getResponse(data.accessToken, slotUrl)
    .then((result) => {
      if(result.status === 'success'){
        data.timeSlots = result.data
        data.timeSlot = ''
      }
      else if(result.status === 'error'){
        data.timeSlots = []
        saveState.saveDisabled = true
        this.setState({errorMsg: result.message, data: data, saveState: saveState})
      }

      if(!data.certification_participation_id && !saveState.saveDisabled){
        this.handleCreateUpdatePartialSave('examDate', data)
      }
      else {
        this.setState({data: data})
      }
    }).catch((error) => {
      this.setState({errorMsg: `Exception ${error.stack}`})
    })
  }

  searchDate(nameKey, testDates){
    for (var i=0; i < testDates.length; i++) {
        if (testDates[i].exam_date === nameKey) {
          return testDates[i].test_date_id;
      }
    }
  }

  handleTQTimeSlotChange = (event) => {
    this.setState({errorMsg: ''})
    let data = Object.assign({}, this.state.data)
    let saveState = Object.assign({}, this.state.saveState)
    data.timeSlot = event.target.value
    if(!data.certification_participation_id && !saveState.saveDisabled){
      this.handleCreateUpdatePartialSave('timeSlot', data)
    }
    else {
      this.setState({data: data})
    }
  }


  handleSubmit = (e) =>{
    e.preventDefault()
    this.processRegistration(false)
  }

  handleSubmitAndProceed = (e) =>{
    e.preventDefault()
    this.processRegistration(true)
  }

  userNameValidate = () => {
      if(this.state.data.user_name !== ''){
        let formErrors = Object.assign({}, this.state.formErrors)
        api.validateUserName(this.state.data.user_name)
        .then((result) => {
          
          if(result.status ==='success'){
            formErrors.userNameUniqueError=''
          }
          else{
            formErrors.userNameUniqueError ='User name is already taken up'
          }
          
          this.setState({formErrors: formErrors})

        })
      }
    }

  phoneValidate = () =>{
    if(this.state.data.phone !== ''){
      let formErrors = Object.assign({}, this.state.formErrors)
      api.validatePhone(this.state.data.countryCode+this.state.data.phone)
      .then((result) => {
        
        if(result.status ==='success'){
          formErrors.phoneUniqueError='success'
        }
        else{
          formErrors.phoneUniqueError ='error'
        }
        
        this.setState({formErrors: formErrors})

      })
    }
  }


  emailValidate = () =>{
    if(this.state.data.email !== ''){
      let formErrors = Object.assign({}, this.state.formErrors)
      var pattern = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
      if(pattern.test(this.state.data.email)){
        
        api.validateEmail(this.state.data.email)
        .then((result) => {
          if(result.status ==='success'){
            formErrors.emailFormatError=''
            formErrors.emailUniqueError='success'
          }
          else{
            formErrors.emailUniqueError ='error'
          }
          
          this.setState({formErrors: formErrors})
          
        })
      }
      else{
        formErrors.emailFormatError ='Invalid Email Format'
        this.setState({formErrors: formErrors})
      }
    }
  }

  validateForm(){

    let error = true
    let errorObj = Object.assign({}, this.state.formErrors)
    let data = Object.assign({}, this.state.data)

    errorObj.firstNameError = ''
    errorObj.lastNameError = ''
    errorObj.emailError = ''
    errorObj.teachingAssociationIdError =''
    errorObj.workingOrganizationError = ''
    errorObj.cityOfResidenceError =''
    errorObj.countryIdError =''
    errorObj.stateIdError =''
    errorObj.testCenterError =''
    errorObj.testTrackError =''
    errorObj.testDateError=''
    errorObj.paymentModeError =''
    errorObj.phoneNumberError =''
    errorObj.userNameError =''
    errorObj.passwordError =''
    errorObj.passwordConfirmationError =''
    errorObj.GenderError =''
    errorObj.emailFormatError =''
    errorObj.examDateOptionError =''
    errorObj.examDateError =''
    errorObj.dobError=''
    errorObj.regPhoneNumberError= ''
    errorObj.tqTestTrackError = ''
    errorObj.timeSlotError = ''


    if(!data.firstName){
        errorObj.firstNameError ='First Name is mandatory'
        error = false
      }

      if(!data.lastName){
        errorObj.lastNameError ='Last Name is mandatory'
        error = false
      }

      if(!data.dob){
        errorObj.dobError ='Date of Birth is mandatory'
        error = false
      }

      if(!(data.email) || data.email === ''){
        errorObj.emailError ='Email is mandatory'
        error = false
      }else{
        var pattern = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
        if(!pattern.test(this.state.data.email)){
          errorObj.emailFormatError = 'Invalid Email Format'
          error = false
        }
      }

      /**if(data.countryId === ''){
        errorObj.countryIdError ='Country is mandatory'
        error = false
      }

      if(data.city === ''){
        errorObj.cityOfResidenceError ='City is mandatory'
        error = false
      }
      **/
      if(!data.teachingAssociationId){
        errorObj.teachingAssociationIdError ='Occupation is mandatory'
        error = false
      }

      if(data.teachingAssociationId && !(data.teachingAssociationName === 'No association with teaching' || data.teachingAssociationName === 'Tuition Teacher')){
        if(data.workingOrganization  === ''){
          errorObj.workingOrganizationError ='Please enter the name of School/Organization/Institute'
          error = false
        }
      }


      if(!data.paymentModeId){
        errorObj.paymentModeError = 'Payment Mode is mandatory'
        error = false
      }

      if(!data.tqTestTrackId){
        errorObj.tqTestTrackError = 'Test Track is mandatory'
        error = false
      }

      if((data.countryId === '1')||(data.countryId === 1)){
        if(data.phone === ''){
          errorObj.phoneNumberError ='Mobile Number is mandatory'
          error = false
        }
        else{
          var phoneno = /^\d{12}$/;
          let fullPhoneNumber = data.countryCode+data.phone
          if(!fullPhoneNumber.match(phoneno)){
            errorObj.phoneNumberError ='Please add country to your mobile number (no space or + needed).'
            error = false
          }
        }
      }
      else {
        var phoneno = /^\d{8,14}$/;
        if((data.regPhoneNumber === '') || (data.regPhoneNumber === null) || (data.regPhoneNumber === undefined)){
          errorObj.regPhoneNumberError = 'Mobile Number is mandatory'
          error = false
        }
        else if(!data.regPhoneNumber.match(phoneno)){
          errorObj.regPhoneNumberError ='Please add country to your mobile number (no space or + needed).'
          error = false
        }
        else if(data.regPhoneNumber.startsWith('91')){
          errorObj.regPhoneNumberError  = 'Invalid Country Code'
          error = false
        }
      }

      if(!data.examDate){
        errorObj.examDateOptionError ='Exam date is mandatory'
        error = false
      }

      if(data.timeSlots.length > 0 && !data.timeSlot){
        errorObj.timeSlotError = 'Please choose a time slot.'
        error = false
      }  

      /**if(data.gender_id === ''){
        errorObj.GenderError ='Gender is mandatory'
        error = false
      }

      if(data.password === ''){
        errorObj.passwordError ='Password is mandatory'
        error = false
      }

      if(data.password_confirmation === ''){
        errorObj.passwordConfirmationError ='Confirm Passowrd is mandatory'
        error = false
      }

      if(data.password !== data.password_confirmation){
        errorObj.passwordError = 'Password and Confirm password are not matching'
        error = false
      }

      if(data.user_name === ''){
        errorObj.userNameError ='User Name is Mandatory'
        error = false
      }
      */

      let saveState = Object.assign({}, this.state.saveState)
      if(!error){        
        saveState.saveDisabled = false
      }
      else{
        saveState.saveDisabled = true
      }

      this.setState({
        formErrors:errorObj,
        errorMsg:'',
        saveState: saveState
      })
      return error
  }


  processReduxStorage = (user_name, accessToken, userId, role) =>{
    //let data = Object.assign({}, this.state.data)
    const obj = {}
    obj.accessToken = accessToken
    obj.userName = user_name
    obj.id = userId
    obj.role = role
    this.props.userLogin(obj)
  }

  processRegistration = (isPayment) => {
    let data = Object.assign({}, this.state.data)
    let certificateName = this.props.match.params.name
    if(this.validateForm()){
      let apiInput = {
       'certification_participation': {
        'certification_type_id': '4',    
        },      
        'tq_certification': {         
          'working_organization': data.workingOrganization,
          'teaching_association_id': data.teachingAssociationId,
          'test_center_id': data.testcenterId,
          'referral_code': data.referralCode,
          'global_type_id': data.tqTypeId,
          'exam_date_option': "Future",
          'selected_exam_date': data.examDate,
          'source_of_reg': `Web_Outside_form_${certificateName}`,
          'time_slot': data.timeSlot 
        },      
        'payment': {
          'payment_mode_id': data.paymentModeId,
          'currency': 'RS'
        },      
        'tq_certification_detail': {
          'tq_test_track_id': data.tqTestTrackId,
          'global_type_id': data.selectedAddonOption,
        },
        'user':{
          'email': data.email,
          'phone': data.regPhoneNumber,
          'password': data.password,
          'password_confirmation': data.password_confirmation,
          'user_name': data.user_name,
          'country_code': data.countryCode,
          'country_id': data.countryId
        },
        'personal_info':{
          'first_name': data.firstName,
          'last_name': data.lastName,
          'gender_id': data.gender_id,
          'dob': data.dob,
        },
        'address':{
          'city': data.city,
          'state_id': data.stateId,
          'country_id': data.countryId
        },
        'payment_option':{
          'is_payment': isPayment
        },
        'cert_part_id': data.certification_participation_id
      }

      if(isPayment){
        ReactGA.set({ userId: 1 });    
        ReactGA.initialize('UA-124053817-1');
        ReactGA.event({
          category: 'Other',
          action: 'Save and Pay CENTA TQ'
        });
      }
      else {
        ReactGA.set({ userId: 1 });
        ReactGA.initialize('UA-124053817-1');
        ReactGA.event({
          category: 'Other',
          action: 'Save Button CENTA TQ'
        });
      }
      // values end
      if(data.certification_participation_id === undefined || data.certification_participation_id === ''){
         api.saveTqCertifications(data.accessToken,apiInput)
        .then((result) => {
          if(result.errors){
            let saveState = Object.assign({}, this.state.saveState)
            saveState.saveDisabled = false
            this.setState({ errorMsg: result.errors, saveState: saveState })
          }
          else if(result.status === 'success'){
            this.processReduxStorage(data.user_name, data.accessToken, data.userId, data.role)
            if(result.redirect_to)
              window.top.location.href = result.redirect_to;
            else{
              window.top.location.href = "/portal/app/my_registrations";        
            }
          }
          else{
            this.setState({errorMsg: 'Unable to Process Request. Please contact Admin'})
          }
        })
        .catch((err) => {
          this.setState({ errorMsg: err.stack })
        })

      } // end of create of new registration

      else{
        //api.updateCentaTQCertification(data.accessToken, apiInput)
        let url = `tq/certification/update/${data.tqId}`
        api.putValuesApi(data.accessToken, url, apiInput)
        .then((result) => {
          if(result.errors){
            let saveState = Object.assign({}, this.state.saveState)
            saveState.saveDisabled = false
            this.setState({ errorMsg: result.errors, saveState: saveState })
          }
          else if (result.status === 'error'){
            let saveState = Object.assign({}, this.state.saveState)
            saveState.saveDisabled = false
            this.setState({ errorMsg: result.message, saveState: saveState })
          }
          else if(result.status === 'success'){
            this.processReduxStorage(data.user_name, data.accessToken, data.userId, data.role)
            if(result.redirect_to)
              window.top.location.href = result.redirect_to;
            else{
              window.top.location.href = "/portal/app/my_registrations";        
            }
          }
          else{
            this.setState({errorMsg: 'Unable to Process Request. Please contact Admin'})
          }
        })
        .catch((err) => {
          this.setState({ errorMsg: err.stack })
        })

      }  // end of update on existing registration

    }
  }

  handleDiscountApply =(e) =>{
    e.preventDefault()
    let data = Object.assign({}, this.state.data)
    let errorObj = Object.assign({}, this.state.formErrors)
    errorObj.discountCouponError = ''
    if(data.tqTestTrackId === ''){
      data.referralCode = ''
      errorObj.discountCouponError = 'Please choose a Test Track to avail discount.'
      this.setState({data: data,formErrors: errorObj})
    }
    else {
      api.getTQDiscountPerTrack('',4, this.state.data.referralCode, data.trackAmount, data.tqTestTrackId, data.selectedAddonOption)
        .then((result) => {
          if(result.status === 'success'){
            data.discountValue =  Number(result.discount)
            data.discountedDollarValue = Number(result.discountedDollarAmount)
            data.registrationFee = data.trackAmount - data.discountValue
            data.registrationFeeInDollar = data.usDollarAmount - data.discountedDollarValue
            data.registrationFeeInDollar = data.registrationFeeInDollar.toFixed(2)
            errorObj.discountCouponError = result.message
          }
          else if(result.status === 'error'){
            errorObj.discountCouponError = result.message
            data.discountValue = 0
            data.registrationFee = data.trackAmount
            data.registrationFeeInDollar = data.usDollarAmount
          }
          else{
            data.discountValue = 0
            data.registrationFee = data.trackAmount
            data.registrationFeeInDollar = data.usDollarAmount
          }
          this.setState({data: data, formErrors: errorObj})
      })
    }
  }


  /* New workflow start */

  genPhoneBasedOTP = (e) => {
    e.preventDefault()
    let errorObj = Object.assign({}, this.state.formErrors)
    let disableState = Object.assign({}, this.state.disableState)
    errorObj.communicationError = ''
    errorObj.countryIdError = ''
    let error = false

    let data = Object.assign({}, this.state.data)
    //data.testCycleId = 6

    let otpGenCount
    otpGenCount = this.state.genOtpCount

    /*country validation */

    if(this.state.data.countryId === ''){
      errorObj.countryIdError = 'Please choose the Country to proceed'
      error = true
    }

    /** validate phone number */
    if(this.state.data.countryId === '1'){
      if(this.state.data.countryCode === '91'){
        if(this.state.data.phone === ''){
          errorObj.communicationError ='Mobile Number is mandatory'
          error = true
        }
        else{
          var phoneno = /^\d{12}$/;
          let fullPhoneNumber = this.state.data.countryCode+this.state.data.phone
          if(!fullPhoneNumber.match(phoneno)){
            errorObj.communicationError ='Please enter a valid 10 digit Mobile Number.'
            error = true
          }
        }
      }
    }
    else{
      if(!(this.state.data.email) || this.state.data.email === ''){
        errorObj.communicationError ='Email is mandatory'
        error = true
      }else{
        var pattern = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
        if(!pattern.test(this.state.data.email)){
          errorObj.communicationError = 'Invalid Email Format'
          error = true
        }
      }
    }

    
    if(this.state.genOtpCount > 4){
      errorObj.genOTPCountError ='You have exceeded maximum number of OTP regenerations allowed. Please WhatsApp us on 7349662401'
      error = true
    }
    
    /** Call api if validation passed */
    if(!error){
      disableState.genOtpState=true
      this.setState({disableState:disableState})
      let regOtp = Object.assign({}, this.state.regOtp)
      let data = Object.assign({}, this.state.data)
      let phoneNumber = data.countryCode+data.phone
      let email = data.email
      let tqAddonOptionURL = `fetch/registration/options/tq`
      let apiInput
      let certificateName = this.props.match.params.name
      if(this.state.data.countryId !== '1'){
        apiInput = {
          'user':{
            'email': data.email,
            'password': data.email,
            'password_confirmation': data.email,
            'user_name': data.email,
            'country_code': data.countryCode,
            'country_id': parseInt(data.countryId),
            'role': 'user'
          },
        }
      }
      else{
        apiInput = {
          'user':{
            'phone': data.phone,
            'password': phoneNumber,
            'password_confirmation': phoneNumber,
            'user_name': phoneNumber,
            'country_code': data.countryCode,
            'country_id': parseInt(data.countryId),
            'role': 'user'
          },
        }
      }
      
      return api.genOTPForRegistration(apiInput)
      .then((result) => {
        
        if(result.status === 'success'){
          regOtp.userId=result.data.user_id
          regOtp.userType=result.data.user_type
          regOtp.otpCode=result.data.otp_code
          regOtp.otpState='otp_generated'
          regOtp.phoneType = result.data.phone_type
          
          otpGenCount = otpGenCount + 1
          //this.setState({ regOtp: regOtp, formErrors: errorObj, genOtpCount:otpGenCount })
        } 
        else{
         disableState.genOtpState = false
         if(result.errors !== undefined)
          errorObj.phoneNumberError=result.errors
         //this.setState({disableState:disableState, formErrors: errorObj}) 
        }
        return api.getTQTestTracks('', certificateName.toUpperCase())
      }).then((result) => {
        data.tqTestTracks = result
        return api.getTqTestCenters('')
      }).then((result) =>{
          data.testcenters = result
          return api.getTeachingAssociations('')
        }).then((result) => {
            data.teachingAssociations = result
            return api.getCountryBasedPaymentModes('',data.countryId)
          }).then((result) =>{
              data.payment_modes = result.data
              return api.getCountries('')            
              }).then((result) => {
                  data.countries = result
                  return api.getStates('', 0)
                }).then((result) =>{
                    data.states = result
                  //   return api.getTQTestDates('', data.testcenterId)
                  // }).then((result) =>{
                  //   data.tqTestDates = result
                  //  return api.getFeeByCertificationType('TQ')
                  //}).then((result) =>{
                  // data.trackAmount = result.amount
                  // data.registrationFee = result.amount
                  // data.usDollarAmount = result.dollar_amount
                  // data.registrationFeeInDollar = result.dollar_amount
                  return api.getTqTypes()
                  }).then((result) =>{
                    data.tqType = result.data
                    data.tqTypeId = result.data[0].id
                    return api.getResponse('', tqAddonOptionURL)
                  }).then((result) =>{
                    data.addOnOptions = result.data
                    this.setState({ regOtp: regOtp, formErrors: errorObj, genOtpCount:otpGenCount, disableState:disableState, data:data})
                  })

    }
    else{
      this.setState({formErrors: errorObj})  
    }
  }

  trackEvent = () => {
    ReactGA.event({
      category: 'OtpConfirmation',
      action: 'click',
    })
  }

  confirmPhoneBasedOTP = (e) => {
    this.trackEvent()
    e.preventDefault()
    let errorObj = Object.assign({}, this.state.formErrors) 
    let disableState = Object.assign({}, this.state.disableState)
    errorObj.userOtpError = ''
    errorObj.regEligibilityError = ''
    errorObj.certificateNameError = false
    let error = false
    /** validate phone number */
    if(this.state.data.userProvidedOtp === '' || this.state.data.userProvidedOtp === undefined || this.state.data.userProvidedOtp === null){
      errorObj.userOtpError ='OTP Code is mandatory'
      error = true
    }
    else{
      var otpValidation = /^\d{6}$/;
      let otpprovided = this.state.data.userProvidedOtp
      if(!otpprovided.match(otpValidation)){
        errorObj.userOtpError ='Please enter a valid OTP Code'
        error = true
      }
    }


    if(!error){

      let regOtp = Object.assign({}, this.state.regOtp)
      let data = Object.assign({}, this.state.data)
      let timeSlots = Object.assign({}, this.state.timeSlots)
      let trackFee = Object.assign({}, this.state.trackFee)
      let disableState = Object.assign({}, this.state.disableState)
      let saveState = Object.assign({}, this.state.saveState)
      let cert_part_id
      let phoneLength
      let tpoUrl = this.state.tpoUrl
      let tqUrl = this.state.tqUrl

      let apiInput
      if(data.countryId === '1') {
        apiInput = {
          'phone': data.phone,
          'country_code': data.countryCode,
          'otp_code': data.userProvidedOtp,
          'user_type': regOtp.userType,
          'phone_type': regOtp.phoneType,
          'reg_type': data.regType,
          'country_id': parseInt(data.countryId)
        }
      }
      else {
        apiInput = {
          'email': data.email,
          'country_code': data.countryCode,
          'otp_code': data.userProvidedOtp,
          'user_type': regOtp.userType,
          'phone_type': regOtp.phoneType,
          'reg_type': data.regType,
          'country_id': parseInt(data.countryId)
        }
      }
      
      
      return api.confirmOTPForRegistration(apiInput)
      .then((result) => {
        let currentDate = this.state.currentDate
        let certificateName = this.props.match.params.name
        let srcOfReg = this.state.srcOfReg
        let confirmOTPLoader = this.state.confirmOTPLoader

        if(result.status === 'success'){
          data.firstName = result.data.first_name
          data.lastName = result.data.last_name
          data.email = result.data.email
          data.dob = result.data.dob
          data.user_name = result.data.user_name
          data.accessToken = result.headers.accessToken
          data.regPhoneNumber = result.data.phone

          if(data.regPhoneNumber === '' || data.regPhoneNumber === undefined || data.regPhoneNumber === null){
            disableState.disablePhone = false
          }
          else{
            disableState.disablePhone = true
          }
          regOtp.otpState='otp_confirmed'
          regOtp.userActivated = true
          disableState.awaitingConf = false
          disableState.disableFieldsOnLoader = false
          data.userId = result.data.user_id
          data.role = result.data.role
          data.certification_participation_id = result.data.certification_participation_id
          data.partialRegId = result.data.partial_reg_id
          saveState.saveDisabled = false
          srcOfReg = result.data.source_of_reg
          tqUrl = result.data.tq_path
          tpoUrl = result.data.tpo_path
          data.tqTestTrackId = result.data.tq_test_track_id
          //data.selectedAddonOption = result.data.is_add_on_available
          this.setState({confirmOTPLoader: true})

          if((srcOfReg) && (srcOfReg.toLowerCase() !== certificateName.toLowerCase()) && (data.certification_participation_id)){
            errorObj.certificateNameError= true
            disableState.awaitingConf = true
            saveState.saveDisabled = true
            disableState.disableFieldsOnLoader = true
            this.setState({regOtp: regOtp, formErrors: errorObj, disableState:disableState, saveState:saveState, srcOfReg: srcOfReg, tpoUrl: tpoUrl, tqUrl: tqUrl })
            return
          }

          else if (((srcOfReg) && (srcOfReg.toLowerCase() !== certificateName.toLowerCase()) && (data.partialRegId))){
            disableState.awaitingConf = true
            saveState.saveDisabled = true
            disableState.disableFieldsOnLoader = true
            this.processReduxStorage(data.user_name, data.accessToken, data.userId, data.role)
            if(result.redirect_to)
              window.top.location.href = result.redirect_to;
            else{
              window.top.location.href = "/portal/app/my_registrations";        
            }
          }

          if(data.certification_participation_id && !data.partialRegId){
            data.tqId = result.data.tq_certification_id
            data.teachingAssociationId = result.data.teaching_association_id
            if(result.data.teaching_association_name !== undefined){
              data.teachingAssociationName = result.data.teaching_association_name
            }
            data.workingOrganization = result.data.working_organization
            data.tqTestTrackId = result.data.tq_test_track_id
            data.isAddOnAVailableForParentTrack = result.data.is_add_on_association_available
            if(data.isAddOnAVailableForParentTrack){
              data.selectedAddonOption = result.data.is_add_on_available
              data.initalAddonAvailableforParentTrack = data.isAddOnAVailableForParentTrack
            }
            data.initialTqTestTrack = data.tqTestTrackId
            data.initialSelectedAddonOption = data.selectedAddonOption
            data.examDateOption = result.data.exam_date_option
            data.examDate = result.data.selected_exam_date
            if(new Date(data.examDate) < currentDate){
              data.examDate = ''             
              data.timeSlot = ''
            }
            else {
              data.timeSlot = result.data.time_slot
            }
            data.paymentModeId = result.data.payment_mode_id
            srcOfReg = result.data.source_of_reg
          }
          else if(data.partialRegId && !data.certification_participation_id){
            data.teachingAssociationId = result.data.teaching_association_id
            if(result.data.teaching_association_name !== undefined){
              data.teachingAssociationName = result.data.teaching_association_name
            }
            data.examDateOption = result.data.exam_date_option
            data.examDate = result.data.selected_exam_date
            if(new Date(data.examDate) < currentDate){
              data.examDate = ''             
              data.examDateOption = ''
              data.timeSlot = ''
            }
            else {
              data.timeSlot = result.data.time_slot
            }
            data.workingOrganization = result.data.working_organization
            data.tqTestTrackId = result.data.tq_test_track_id
            data.isAddOnAVailableForParentTrack = result.data.is_add_on_association_available
            if(data.isAddOnAVailableForParentTrack){
              data.selectedAddonOption = result.data.is_add_on_available
            } 
          }

          if(data.tqTestTrackId && !data.tqTestTracks.some(track => track.id === parseInt(data.tqTestTrackId))){
            data.tqTestTrackId = ''
            data.selectedAddonOption = ''
            data.examDate = ''
          }
          if(data.tqTestTrackId){
            api.getResponse(data.accessToken, `/fetch/tq/track/fee/${data.tqTestTrackId}`)
              .then((result) =>{
                if(result.status === 'success'){
                  data.trackAmount = result.data.amount
                  data.registrationFee = result.data.amount
                  data.usDollarAmount = result.data.dollar_amount
                  data.registrationFeeInDollar = result.data.dollar_amount
                // incase ofaddon should be separtely stored for display purpose
                  data.trackFeeWithoutAddon = result.data.amount
                  data.trackFeeInDolloarWithoutAddon = result.data.dollar_amount
                  data.trackFeeWithAddon = result.data.add_on_amount
                  data.trackFeeInDolloarWithAddon = result.data.add_on_dollar_amount
                  data.initialFee = result.data.inital_fee
                  data.initialFeeWithAddOn = result.data.inital_fee_with_add_on
                // if the user has opted for online option initally and if he is trying to update
                  if(data.selectedAddonOption){
                    data.trackAmount = data.trackFeeWithAddon
                    data.registrationFee = data.trackFeeWithAddon
                    data.usDollarAmount = data.trackFeeInDolloarWithAddon
                    data.registrationFeeInDollar = data.trackFeeInDolloarWithAddon
                  }
                  
                  if(data.tqTestTrackId){
                    return api.getResponse(data.accessToken, `fetch/date/time/slot?type=exam_date&tq_test_track_id=${data.tqTestTrackId}`)
                    .then((result) => {
                      if(result.status === 'error'){ 
                        saveState.saveDisabled = true
                        this.setState({regOtp: regOtp, formErrors: errorObj, data: data, disableState:disableState, saveState:saveState, confirmOTPLoader: false, errorMsg: result.message})
                        return
                      }
                      data.tqTestDates = result.data
                      if(data.examDate && data.tqTestDates.length > 0){
                        let testDateId = this.searchDate(data.examDate, data.tqTestDates)
                        if(testDateId){
                          return api.getResponse(data.accessToken, `fetch/date/time/slot?type=time_slot&tq_test_track_id=${data.tqTestTrackId}&test_date_id=${testDateId}`)
                          .then((result) =>{
                          if(result.status === 'success'){  
                            data.timeSlots = result.data
                          }
                          this.setState({regOtp: regOtp, formErrors: errorObj, data: data, disableState:disableState, saveState:saveState, confirmOTPLoader: false})
                          return
                          })
                        } else {
                          data.examDate = ''
                          data.timeSlots = ''
                          data.timeSlot = ''
                        }
                        this.setState({regOtp: regOtp, formErrors: errorObj, data: data, disableState:disableState, saveState:saveState, confirmOTPLoader: false })
                        return
                      }
                    this.setState({ regOtp: regOtp, formErrors: errorObj, data: data, disableState:disableState, saveState:saveState, confirmOTPLoader: false })
                    return
                  })
                }
              }
              this.setState({ regOtp: regOtp, formErrors: errorObj, data: data, disableState:disableState, saveState:saveState, confirmOTPLoader: false })
              return
            })
          }
          this.setState({ regOtp: regOtp, formErrors: errorObj, data: data, disableState:disableState, saveState:saveState, confirmOTPLoader: false })  
        }

        else if(result.status === 're-direct'){
          if(result.data.reg_eligibility === 're-direct'){
            //errorObj.regEligibilityError = result.message
            // disableState.disableConfirmRegen = true
            // disableState.regEligibilityHidden = false
            // this.setState({formErrors: errorObj, disableState: disableState, data: data})
            // return
            data.user_name = result.data.user_name
            data.accessToken = result.headers.accessToken
            data.userId = result.data.user_id
            data.role = result.data.role
            this.processReduxStorage(data.user_name, data.accessToken, data.userId, data.role)
            if(result.redirect_to)
              window.top.location.href = result.redirect_to;
            else{
              window.top.location.href = "/portal/app/my_registrations";        
            }
          }
          else{
            errorObj.userOtpError = result.errors
            this.setState({ regOtp: regOtp, formErrors: errorObj, disableState:disableState}) 
            return
          } 
        }
        else if(result.status === 'not_eligible'){
          errorObj.regEligibilityError = result.message
          disableState.disableConfirmRegen = true
          disableState.regEligibilityHidden = false
          this.setState({formErrors: errorObj, disableState: disableState, data: data})
          return
        }
        //OTP expired error message
        else if(result.status === 'error'){
          errorObj.userOtpError = result.errors
          this.setState({formErrors: errorObj})
        }

      }).catch((err) => {
        this.setState({ errorMsg: err.stack, formErrors: errorObj })
      })
      
    }
    else{
      this.setState({formErrors: errorObj})
    }

    
  }


  /** Partial Save form support start */


  handleSaveTPOFirstName = (e) => {

    let errorObj = Object.assign({}, this.state.formErrors)
    let data = Object.assign({}, this.state.data)
    
    if(data.firstName === ''){
      return
    }

    if(this.state.partialPersonalFirstSave === 'in_progress')
    {
      return
    }

    if(this.state.partialPersonalFirstSave === 'not_started'){
      this.setState({partialPersonalFirstSave: 'in_progress '})
    }
    let apiInput = {
          'personal_info':{
            'first_name': data.firstName,
            
          }
        }
      
      api.saveRegistrationPersonalInfo(data.accessToken, apiInput)
      .then((result) => {
        
        if(result.status === 'success'){
          if(this.state.partialPersonalFirstSave === 'in_progress'){
           this.setState({partialPersonalFirstSave: 'completed'})
          }               
        } 
        else if(result.status === 'error'){
          if(this.state.partialPersonalFirstSave === 'in_progress'){
           this.setState({partialPersonalFirstSave: 'not_started'})
          }
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack })
      })
  }

  handleSaveTPOLastName = (e) => {

    let errorObj = Object.assign({}, this.state.formErrors)
    let data = Object.assign({}, this.state.data)
    
    if(data.lastName === ''){
      return
    }

    if(this.state.partialPersonalFirstSave === 'in_progress')
    {
      return
    }

    if(this.state.partialPersonalFirstSave === 'not_started'){
      this.setState({partialPersonalFirstSave: 'in_progress '})
    }

    let apiInput = {
          'personal_info':{
            
            'last_name': data.lastName,
          }
        }
      
      api.saveRegistrationPersonalInfo(data.accessToken, apiInput)
      .then((result) => {
        
        if(result.status === 'success'){
          if(this.state.partialPersonalFirstSave === 'in_progress'){
           this.setState({partialPersonalFirstSave: 'completed'})
          }          
        } 
        else if(result.status === 'error'){
          if(this.state.partialPersonalFirstSave === 'in_progress'){
           this.setState({partialPersonalFirstSave: 'not_started'})
          }
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack })
      })
  }

  handleSaveTPODob = (e) => {

    let errorObj = Object.assign({}, this.state.formErrors)
    let data = Object.assign({}, this.state.data)
    
    if(data.lastName === ''){
      return
    }

    if(this.state.partialPersonalFirstSave === 'in_progress')
    {
      return
    }

    if(this.state.partialPersonalFirstSave === 'not_started'){
      this.setState({partialPersonalFirstSave: 'in_progress '})
    }

    let apiInput = {
          'personal_info':{
            
            'dob': data.dob,
          }
        }
      
      api.saveRegistrationPersonalInfo(data.accessToken, apiInput)
      .then((result) => {
        
        if(result.status === 'success'){
          if(this.state.partialPersonalFirstSave === 'in_progress'){
           this.setState({partialPersonalFirstSave: 'completed'})
          }          
        } 
        else if(result.status === 'error'){
          if(this.state.partialPersonalFirstSave === 'in_progress'){
           this.setState({partialPersonalFirstSave: 'not_started'})
          }
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack })
      })
  }


  handleSaveUserInfoEmail = (e) => {

    let errorObj = Object.assign({}, this.state.formErrors)
    let data = Object.assign({}, this.state.data)
    errorObj.emailError = ''
    errorObj.emailFormatError = ''
    
    if(this.state.data.email !== undefined && this.state.data.email !== ''){
      let formErrors = Object.assign({}, this.state.formErrors)
      var pattern = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
      if(!pattern.test(this.state.data.email)){
        errorObj.emailFormatError = 'Invalid Email Format. Please check'
        this.setState({formErrors: errorObj})
      }
      else{
        let apiInput = {
          'user':{
          'email': data.email,
          }
        } 
      api.partialSaveUserInfo(data.accessToken, apiInput)
      .then((result) => {
       if(result.status === 'success'){
          errorObj.emailError = ''           
        } 
        else if(result.status === 'error'){
          errorObj.emailError = result.errors
        }
        this.setState({formErrors: errorObj})
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack })
      })
      }
    }

    else{
      errorObj.emailError = "Email is mandatory"
      this.setState({formErrors: errorObj})
    }
  
  }
 
  handleSaveUserInfoPhone = (e) =>{
    let errorObj = Object.assign({}, this.state.formErrors)
    let data = Object.assign({},this.state.data)
    errorObj.regPhoneNumberError = ''
    var phoneno = /^\d{8,14}$/
    if(data.regPhoneNumber === '' || data.regPhoneNumber === undefined || data.regPhoneNumber === null){
      errorObj.regPhoneNumberError  = 'Please add country to your mobile number (no space or + needed).'
      this.setState({formErrors: errorObj})
      return
    }
    if((data.countryId !== '1') || (data.countryId !== 1)){    
      if(data.regPhoneNumber.startsWith('91')){
        errorObj.regPhoneNumberError  = 'Invalid Country Code'
        this.setState({formErrors: errorObj})
        return
      } 
    }
    if(!data.regPhoneNumber.match(phoneno)){
      errorObj.regPhoneNumberError ='Please add country to your mobile number (no space or + needed).'
      this.setState({formErrors: errorObj})
      return
    }
    let apiInput = {
      user:{
        phone: data.regPhoneNumber,
      }
    }
    api.partialSaveUserInfo(data.accessToken, apiInput)
    .then((result) =>{
      if(result.status === 'success'){
        errorObj.regPhoneNumberError = ''
      }
      else if (result.status === 'error'){
        errorObj.regPhoneNumberError = result.message 
      }
      this.setState({formErrors: errorObj})
    })
   .catch((err) => {
      this.setState({ errorMsg: err.stack })
    })
  }

  callPartialSave = (e, type) =>{
    e.preventDefault()
    let data = Object.assign({}, this.state.data)
    if(!data.certification_participation_id){
      this.handleCreateUpdatePartialSave(type, data)
    }
  }

  handleCreateUpdatePartialSave = (type, data) => {
    let saveState = Object.assign({}, this.state.saveState)
    let certificateName = this.props.match.params.name.toUpperCase()
    let currentDate = this.state.currentDate
    let selectedDate = ''
    let partialLoader = this.state.partialLoader
    let disableState = Object.assign({}, this.state.disableState)

    if(!data.tqTestTrackId){
      data.tqTestTrackId = ''
    }

    if(!data.selectedAddonOption){
      data.selectedAddonOption = ''
    }

    if(!data.examDate){
      data.examDate = ''
    }

    if(!data.timeSlot){
      data.timeSlot = ''
    }
  
    let apiInput = {
      "partial_registration": {
        "certification_type_id": 4, 
        "state_of_reg": "open", 
        "registration_detail": 
          { 
          "tq_test_track_id": data.tqTestTrackId,
          "global_type_id": data.selectedAddonOption, 
          "teaching_association_id": data.teachingAssociationId, 
          "exam_date_option": "Future",
          "selected_exam_date": data.examDate,
          "time_slot": data.timeSlot,
          "working_organization": data.workingOrganization,
          "source_of_reg":`Web_Outside_form_${certificateName}`,
        }
      }
    }

    if(!data.partialRegId){
      let url = `partial_registrations`
      saveState.saveDisabled = true
      disableState.disableFieldsOnLoader = true
      this.setState({partialLoader: true, saveState: saveState, disableState: disableState})
      api.postValuesApi(data.accessToken, url, apiInput)
      .then((result) => {
        partialLoader = false
        saveState.saveDisabled = false
        disableState.disableFieldsOnLoader = false
        if (result.status === 'error'){
          this.setState({errorMsg: result.data, partialLoader: partialLoader, saveState: saveState, disableState: disableState})
          }
        else if(result.status === 'success'){
          data.partialRegId = result.data.id 
          this.setState({data: data, partialLoader: partialLoader, saveState: saveState, disableState: disableState})
        }
      })
    }
    else if(data.partialRegId){
      let url = `partial_registrations/${data.partialRegId}`
      saveState.saveDisabled = true
      disableState.disableFieldsOnLoader = true
      let errorMsg = this.state.errorMsg
      this.setState({partialLoader: true, saveState: saveState, disableState: disableState})
      api.putValuesApi(data.accessToken, url, apiInput)
      .then((result) => {
        if (result.status === 'error'){
          partialLoader = false
          saveState.saveDisabled = false
          this.setState({errorMsg: result.data, partialLoader: partialLoader, saveState: saveState})
          }
        else if(result.status === 'success'){
          //if(result.reg_status!== 'complete'){
            partialLoader = false
            saveState.saveDisabled = false
            disableState.disableFieldsOnLoader = false
            this.setState({data: data, saveState: saveState, partialLoader: partialLoader, disableState: disableState})
          //}
          // else if(!data.certification_participation_id && result.reg_status === 'complete'){ 
          //   let saveApiInput = {
          //     'certification_participation': {
          //       'certification_type_id': '4',    
          //       },      
          //       'tq_certification': {         
          //         'working_organization': data.workingOrganization,
          //         'teaching_association_id': data.teachingAssociationId,
          //         'test_center_id': data.testcenterId,
          //         'referral_code': data.referralCode,
          //         'global_type_id': data.tqTypeId,
          //         'exam_date_option': data.examDateOption,
          //         'selected_exam_date': data.examDate,
          //         'source_of_reg': `Web_Outside_form_${certificateName}` 
          //       },      
          //       'payment': {
          //         'payment_mode_id': data.paymentModeId,
          //         'currency': 'RS'
          //       },      
          //       'tq_certification_detail': {
          //         'tq_test_track_id': data.tqTestTrackId,
          //         'global_type_id': data.selectedAddonOption,
          //       },
          //       'user':{
          //         'email': data.email,
          //         'phone': data.regPhoneNumber,
          //         'password': data.password,
          //         'password_confirmation': data.password_confirmation,
          //         'user_name': data.user_name,
          //         'country_code': data.countryCode,
          //         'country_id': data.countryId
          //       },
          //       'personal_info':{
          //         'first_name': data.firstName,
          //         'last_name': data.lastName,
          //         'gender_id': data.gender_id,
          //         'dob': data.dob,
          //       },
          //       'address':{
          //         'country_id': data.countryId
          //       },
          //       'payment_option':{
          //         'is_payment': false
          //       },
          //     }
          //   return api.saveTqCertifications(data.accessToken, saveApiInput)
          //   .then((result) => {
          //     partialLoader = false
          //     if(data.isAddOnAVailableForParentTrack){
          //       //data.selectedAddonOption = result.data.is_add_on_available
          //       data.initalAddonAvailableforParentTrack = data.isAddOnAVailableForParentTrack
          //     }
          //     data.initialTqTestTrack = data.tqTestTrackId
          //     data.initialSelectedAddonOption = data.selectedAddonOption 
              
          //     if(result.errors){
          //       saveState.saveDisabled = false
          //       disableState.disableFieldsOnLoader = false
          //       this.setState({ errorMsg: result.errors, saveState: saveState, partialLoader: partialLoader })
          //     }
          //     else if (result.status === 'success'){
          //       data.certification_participation_id = result.data.id
          //       data.tqId = result.tq_certification_id
          //       saveState.saveDisabled = false
          //       disableState.disableFieldsOnLoader = false
          //       errorMsg= ''
          //       this.setState({data: data, saveState: saveState, partialLoader: partialLoader, errorMsg: errorMsg, disableState: disableState})
          //     }
          //   })
          // }
        }
      })
    }
  } 

  /* Partial Save support end */

  /* New Workflow end */


  render() {
    let tqTypeComponent
    tqTypeComponent = (
      <div className="full-width">
        <div className="mdc-select" role="listbox">
          <select
            name="type"
            onChange={this.handletqTypeChange}
            value={this.state.data.tqTypeId}
            disabled
            className="mdc-select__native-control two-col-input">
            {this.state.data.tqType.map(function(tqTypes){
                return(<option key={tqTypes.id} value={tqTypes.id} data-name={tqTypes.name}>
                  {tqTypes.name} 
                </option>)
            })}
          </select>
          <label className="mdc-floating-label mdc-floating-label--float-above">Type</label>
          <div className="mdc-line-ripple"></div>
        </div>
      </div>)

    let TeachingOtherComponent
    if(this.state.data.teachingAssociationId && !(this.state.data.teachingAssociationName === 'No association with teaching' || this.state.data.teachingAssociationName === 'Tuition Teacher')){

      TeachingOtherComponent =(
        <PlacesAutoComplete
          value={this.state.data.workingOrganization}
            onChange={this.handleSchoolSelect}
            onSelect={this.handleSchoolChange}
            onBlur={(e) => this.callPartialSave(e, 'workingOrganization')}
            >
            {({ getInputProps, suggestions, getSuggestionItemProps }) => (
            <div>
              <TextField
                {...getInputProps({
                  placeholder: 'School/Organization/Institute',
                  className: 'location-search-input'
                })}
                name="school"
                
              />
              <div className="autocomplete-dropdown-container">
                {suggestions.map(suggestion => {
                  const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
                  // inline style for demonstration purpose
                  const style = suggestion.active
                              ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                              : { backgroundColor: '#ffffff', cursor: 'pointer' };
                  return (
                    <div {...getSuggestionItemProps(suggestion, { className, style })}>
                      <span>{suggestion.description}</span>
                    </div>
                  )
                })}
              </div>
            </div>
          )}
        </PlacesAutoComplete>
      )
    }


    let regAmountComponent
    let discountTextComponent
    if(this.state.data.trackAmount > 0){
      let regFee = this.state.data.registrationFee
      let regFeeWithoutGST = regFee / 1.18
      let initialFee;
      if(this.state.data.selectedAddonOption === '') {
        initialFee = this.state.data.initialFee
      }
      else if (this.state.data.selectedAddonOption !== ''){
        initialFee = this.state.data.initialFeeWithAddOn
      }
      //regAmountComponent = <h4> Total registration fee Rs {this.state.data.registrationFee}{'/-'} (Rs.{parseFloat(regFeeWithoutGST).toFixed(2)} + 18% GST) approx ${this.state.data.registrationFeeInDollar} in US dollars.</h4>
      let percentDiscount = Math.floor((100-(regFeeWithoutGST/initialFee)*100))
      //discountTextComponent = <h5> (Post a {percentDiscount}% discount on the original fee of INR 1500 + GST) </h5>
      if(this.state.data.countryId === '1' || this.state.data.countryId === 1){
        regAmountComponent = <p> Registration fee: <del>Rs {initialFee} + GST</del> <b>You Pay:</b> Rs {parseFloat(regFeeWithoutGST).toFixed(2)} + GST(Rs {this.state.data.registrationFee}).<br/>{percentDiscount}% discount.</p>
      }
      else {
        regAmountComponent = <p>Registration fee: USD {parseFloat(this.state.data.registrationFeeInDollar).toFixed(2)}. {percentDiscount}% discount.</p>
      }
    }
    //else{
    //  regAmountComponent = <h4> Total Registraion Fee Rs. {this.state.data.registrationFee} /-</h4>  
    //}


    let paymentModeComponent

    paymentModeComponent = (
      <div className="full-width">
        <div className="mdc-select" role="listbox">
          <select 
            disabled={this.state.disableState.awaitingConf}
            name="payment_mode"
            onChange={this.handlePaymentModeChange}
            value={this.state.data.paymentModeId}
            className="mdc-select__native-control two-col-input"
          >
            <option value="" selected="">--Select Payment Mode--</option>
            {this.state.data.payment_modes.map(payment_mode =>(
                <option key={payment_mode.id} value={payment_mode.id} data-name={payment_mode.name}>
                  {payment_mode.name} 
                </option>
            ))}
          </select>
          <label className="mdc-floating-label mdc-floating-label--float-above">Payment Options</label>
          <div className="mdc-line-ripple"></div>
        </div>
      </div>)

    let phoneValidateMsgComponent
      if(this.state.formErrors.phoneUniqueError === 'error'){
        phoneValidateMsgComponent = (
          <div className="error-style">
            Mobile Number already taken. Click <Link to="/portal/signin"> here </Link> to login
          </div>
        )
      }

      let emailValidateMsgComponent
      if(this.state.formErrors.emailUniqueError === 'error'){
        emailValidateMsgComponent = (
          <div className="error-style">
            Email already taken. Click <Link to="/portal/signin"> here </Link> to login
          </div>
        )
      }

    /** New changes work flow start */
      let otpConfComponent

      if(this.state.regOtp.otpState === 'otp_generated'){
        otpConfComponent =(<div>
            <TextField label="OTP Code" autoComplete="off" name="userProvidedOtp" onChange={this.onInputChange} value={this.state.data.userProvidedOtp} disabled={this.state.disableState.disableConfirmRegen}/>
            <Button className="reg-form-button-margin" theme="secondary-bg on-secondary" onClick={this.confirmPhoneBasedOTP} disabled={this.state.disableState.disableConfirmRegen}>Confirm OTP</Button>            
            <Button className="reg-form-button-margin" theme="secondary-bg on-secondary" onClick={this.genPhoneBasedOTP} disabled={this.state.disableState.disableConfirmRegen}>Regenerate OTP</Button>
            <br/><Typography use="caption"> OTP Sent to registered mobile number </Typography>
            <StatusMessage error_msg = {this.state.formErrors.userOtpError}/>
            <StatusMessage error_msg = {this.state.formErrors.genOTPCountError}/>
            
          </div>)
      }  


      let userNameComponentDisplay
      if(!this.state.disableState.awaitingConf){
        if(this.state.regOtp.userType === 'new user'){
          userNameComponentDisplay = (<div><br/><b>Welcome!</b>  Your Username is  <u><b>{this.state.data.user_name}</b></u>. Please make a note of this.</div>) 
        }
        else if(this.state.regOtp.userType === 'existing user'){
          userNameComponentDisplay = (<div><br/><b>Welcome back!</b>  Your MyCENTA Username is <u><b>{this.state.data.user_name}</b></u>. Please make a note of this.</div>) 
        }
      }

      /** New changes work flow end */

    let examDateComponent
    let tempComponent
    if(this.state.data.examDateOption === 'Future'){
      examDateComponent = (<GridCell span="6">
        <TextField type="date" fullwidth style={{paddingTop:'15px'}} min={this.state.currentDate} className="datepicker-padding" label="Exam Date" autoComplete="off" name="examDate" onChange={this.onInputChange} value={this.state.data.examDate} onBlur={(e) => this.callPartialSave(e, 'examDate')}/>
      </GridCell>)
      tempComponent = (<GridCell span="6" />)
    }




    let saveButtonComponent, communicationPhoneComponent, formCommunicationComp,verifyMsgComponent, countryComponent, communicationEmailComponent;
    countryComponent = (
      <GridCell span = "12">
        <Select
          name = "country_id"
          onChange = {this.handleCountriesChange}
          value = {this.state.data.countryId}
          placeholder = "Please choose the country"
          disabled={this.state.disableState.genOtpState}
        >
          {this.state.data.countries.map(country =>(
            <option key = {country.id} value = {country.id} name = {country.name}>
            {country.name}
            </option>
          ))}
        </Select>
      </GridCell>
      )

    if(this.state.data.countryId === '1'){
      communicationPhoneComponent = (
        <GridCell span = "12">
            <TextField className='text_input' disabled className="country-code" label="Code" autoComplete="off"  name="countryCode" value={this.state.data.countryCode}/>
            &nbsp;
            <TextField  className='text_input' label="Mobile No." autoComplete="off"  type="number" name="phone" disabled={this.state.disableState.genOtpState} onChange={this.onInputChange} value={this.state.data.phone} />
        </GridCell>  
      )   
      formCommunicationComp = (<TextField fullwidth className='text_input' label="Email" autoComplete="off"  name="email" onChange ={this.onInputChange} value={this.state.data.email} onBlur={this.handleSaveUserInfoEmail} disabled={this.state.disableState.awaitingConf}/>)
      verifyMsgComponent = (<Typography use="caption"> An OTP will be sent to your mobile once you click on Verify. Please enter it below. </Typography>)
    }
    else if(this.state.data.countryId !== '1'){
      communicationEmailComponent = (<TextField fullwidth className='text_input' label="Email" autoComplete="off"  name="email" disabled={this.state.disableState.genOtpState} onChange={this.onInputChange} value={this.state.data.email} />)
      formCommunicationComp = (
        <GridCell span = "12">
            <TextField className='text_input' label="Registration Mobile No." autoComplete="off"  name="regPhoneNumber" type="number" onChange = {this.onInputChange} value={this.state.data.regPhoneNumber} disabled={this.state.disableState.disablePhone} onBlur={this.handleSaveUserInfoPhone}/>
        </GridCell>)
      verifyMsgComponent = (
                  <Typography use="caption"> An OTP will be sent to your email once you click on Verify. Please enter it below. </Typography>)
    }

    //if(this.state.data.countryId === '1'){
      saveButtonComponent = (
        <GridCell span = "12">
            <GridCell span="6">
              <Button raised disabled={this.state.saveState.saveDisabled}>Save</Button>
              <Button raised onClick={this.handleSubmitAndProceed} className="confirm-proceed-button" disabled={this.state.saveState.saveDisabled}>Save & Pay</Button>
            </GridCell> 
        </GridCell> 
        )
     //}
    /*else {
      saveButtonComponent = (
        <GridCell span="6">
          <Button raised disabled={this.state.saveState.saveDisabled}>Save</Button>
        </GridCell> 
      ) 
    }*/

    let trackEligbilityComponent
    if(this.state.data.eligibility === 'not_eligible' && (this.state.data.tqTestTrackId != this.state.data.initialTqTestTrack)){
      if(this.state.data.paymentStatus === 'Pending'){
        trackEligbilityComponent = (
          <GridCell span="12" style={{color: "red"}}>
            {this.state.data.trackDetailMessage}
            {/*<br/>
            <a href='https://m.centa.org' target="_blank">Click here to visit MyCENTA</a>
            <Typography use ='subtitle'>, go to the My Registrations section and pay the fee to take the test.</Typography>*/}
          </GridCell>
        )
      }

      else {
        trackEligbilityComponent = (
          <GridCell span="12" style={{color: "red"}}>{this.state.data.trackDetailMessage}</GridCell>
        )
      }
    }

    //add On Option component
    let isTrackSelectedAndAddonAvailable = false
    if(this.state.data.tqTestTrackId !== '' && this.state.data.isAddOnAVailableForParentTrack !== ''){
      isTrackSelectedAndAddonAvailable = true
    }
    let addonOpptionComp = (

      <GridCell span="12">
        {this.state.data.addOnOptions.map(addonOption => (
          <label>

            <input type="checkbox" disabled={!isTrackSelectedAndAddonAvailable || this.state.disableState.disableFieldsOnLoader || this.state.disableState.examDateDisabled} name="selectedAddonOption" value={addonOption.id} checked={this.state.data.selectedAddonOption === addonOption.id } onChange={this.onAddonOptionChange} style={{verticalAlign: 'sub', zoom: '1.5', marginRight: '6px'}}/>
            
            Select this if you want to take up the 'Online Teaching' component in addition to this track (additional fee of INR 400 applicable). 
          
          </label>
        ))}
      </GridCell>

    )
    
    let certificateName = this.props.match.params.name
    let certificateNameErrorComponent, url
    if(this.state.formErrors.certificateNameError){
      if(this.state.srcOfReg === 'TPO')
        url = this.state.tpoUrl
      else if(this.state.srcOfReg === 'TQ')
        url = this.state.tqUrl
      certificateNameErrorComponent = (
        <div style={{color: 'red'}}>
          There is a pending registration for CENTA TQ (also TPO prelims) with the above number. Please <a href= {url} target="_blank">Click here</a> to complete your registration.
        </div>
      )
    }

    let partialLoadingComponent
      if(this.state.partialLoader){
        partialLoadingComponent = (
            <div>
              <div className="loader"></div>
              <h4>Details are getting loaded. Please wait</h4>
            </div>
          )
      }

      let confirmOTPLodingComponent
      if(this.state.confirmOTPLoader){
        confirmOTPLodingComponent = (
            <div>
              <div className="loader"></div>
              <h4>Details are getting loaded. Please wait</h4>
            </div>
          )
      }
    

    let emailErrorComponent
    if(this.state.formErrors.emailError){
      emailErrorComponent = (
        <GridCell span="12">
          <StatusMessage error_msg = "Please contact team@centa.org for assistance"/>
        </GridCell>
      )
    }

     let listDateComponent
      listDateComponent = (
        <GridCell span="6">
          <div className="full-width">
            <div className="mdc-select" role="listbox">
              <select 
                name="testDate"
                onChange={this.handleTQTestDateChange}
                value={this.state.data.examDate}
                className="mdc-select__native-control two-col-input"
                disabled={this.state.disableState.disableFieldsOnLoader || this.state.disableState.awaitingConf || this.state.saveState.saveDisabled} 
              >
                <option value="" selected="">--Select Exam Date--</option>
                {this.state.data.tqTestDates.map(testDate => (
                  <option key={testDate.test_date_id} value={testDate.examDate} data-name={testDate.exam_date}>
                    {testDate.exam_date} 
                  </option>
                ))}
              </select>
              <label className="mdc-floating-label mdc-floating-label--float-above">Exam Date</label>
              <div className="mdc-line-ripple"></div>
            </div>
          </div>
        </GridCell>
      ) 

    let timeSlotComponent
    if(this.state.data.timeSlots.length > 0){
      timeSlotComponent = (
        <GridCell span="6">
          <div className="full-width">
            <div className="mdc-select" role="listbox">
              <select 
                name="testcenter"
                onChange={this.handleTQTimeSlotChange}
                value={this.state.data.timeSlot}
                className="mdc-select__native-control two-col-input"
                disabled={this.state.disableState.disableFieldsOnLoader || this.state.disableState.awaitingConf || this.state.saveState.saveDisabled} 
              >
                <option value="" selected="">--Select Time Slot--</option>
                {this.state.data.timeSlots.map(slot => (
                  <option key={slot.time_slot_id} value={slot.timeSlot} data-name={slot.time_slot}>
                    {slot.time_slot} 
                  </option>
                ))}
              </select>
              <label className="mdc-floating-label mdc-floating-label--float-above">Time Slot</label>
              <div className="mdc-line-ripple"></div>
            </div>
          </div>
        </GridCell>

      )
    }

    return (
      <Grid>
        <GridCell span="12">
          <form onSubmit={this.handleSubmit} style={{width: '100%'}}>
            <Card style={{padding: '25px'}}>
              <Typography use="headline5">CENTA {certificateName} Registration Form</Typography>

              <Grid className="opportunity-list-item">
                
                <GridCell span="6">
                <div>
                  {countryComponent}
                  <StatusMessage error_msg = {this.state.formErrors.countryIdError}/>
                  {communicationPhoneComponent}
                  {communicationEmailComponent}
                  {phoneValidateMsgComponent}
                  <StatusMessage error_msg = {this.state.formErrors.phoneNumberError}/>
                  <Button className="reg-form-button-margin" theme="secondary-bg on-secondary" disabled={this.state.disableState.genOtpState} onClick={this.genPhoneBasedOTP}>VERIFY</Button>
                  <br/>
                  {verifyMsgComponent}
                  <StatusMessage error_msg = {this.state.formErrors.communicationError}/>
                </div>
                </GridCell>
                <GridCell span="6">
                </GridCell>

                <GridCell span="6">
                  {otpConfComponent}
                  <div style={{color: "red"}} hidden ={this.state.disableState.regEligibilityHidden}>
                    {this.state.formErrors.regEligibilityError}
                    please go to the My Registrations section in the <a href='https://m.centa.org' target="_blank">MyCENTA</a> app and complete the payment of the fee.
                  </div>
                  {userNameComponentDisplay}
                  <div>
                    {certificateNameErrorComponent}
                  </div>
                </GridCell>
                <GridCell span="6"/>
                <GridCell span="6">
                  <TextField fullwidth className='text_input' label="First Name" autoComplete="off" name="firstName" disabled={this.state.disableState.awaitingConf} onChange={this.onInputChange} value={this.state.data.firstName} onBlur={this.handleSaveTPOFirstName}/>
                </GridCell>
                <GridCell span="6"></GridCell>
                
                <GridCell span="6">                  
                  <TextField fullwidth className='text_input' label="Last Name" autoComplete="off"  name="lastName" disabled={this.state.disableState.awaitingConf} onChange={this.onInputChange} value={this.state.data.lastName} onBlur={this.handleSaveTPOLastName}/>
                </GridCell>
                <GridCell span="6"></GridCell>
                
                <GridCell span="6">
                  {formCommunicationComp}
                  {emailValidateMsgComponent}
                  <StatusMessage error_msg = {this.state.formErrors.emailFormatError}/>
                  <StatusMessage error_msg = {this.state.formErrors.emailError}/>
                  {emailErrorComponent}
                  <StatusMessage error_msg = {this.state.formErrors.regPhoneNumberError}/>
                </GridCell>
                <GridCell span="6"></GridCell>


                 <GridCell span="6">
                  <TextField type="date" fullwidth style={{paddingTop:'15px'}} className = 'datepicker-padding' max={this.state.currentDate} label="Date of Birth" autoComplete="off"  name="dob" onChange={this.onInputChange} value={this.state.data.dob} disabled={this.state.disableState.awaitingConf} onBlur={this.handleSaveTPODob}/>
                </GridCell>
                <GridCell span="6"></GridCell>
                
                <GridCell span="6">
                 <div className="full-width">
                    <div className="mdc-select" role="listbox">
                      <select
                        disabled={this.state.disableState.disableFieldsOnLoader || this.state.disableState.awaitingConf} 
                        name="teachingAssociation"
                        onChange={this.handleTeachingAssociationSelection}
                        value={this.state.data.teachingAssociationId}
                        className="mdc-select__native-control two-col-input"
                      >
                        <option value="" selected="">--Select Occupation--</option>
                        {this.state.data.teachingAssociations.map(level => (
                          <option key={level.id} value={level.id} data-name={level.name}>
                            {level.name}
                          </option>
                        ))}
                      </select>
                      <label className="mdc-floating-label mdc-floating-label--float-above">Occupation</label>
                      <div className="mdc-line-ripple"></div>
                    </div>
                  </div>
                </GridCell>
                <GridCell span="6"> </GridCell>

                <GridCell span="6">
                  {TeachingOtherComponent}
                </GridCell>
                <GridCell span="6"/>
               {/*<GridCell span="6">
                  Take the test on: 
                  <Radio disabled={this.state.disableState.disableFieldsOnLoader || this.state.disableState.awaitingConf} name="examDateOption" value="Immediate" checked={this.state.data.examDateOption == 'Immediate'} onChange={this.onInputChange} onBlur={(e) => this.callPartialSave(e, 'examDateOption')}>
                    Today
                  </Radio>
                  <Radio disabled={this.state.disableState.disableFieldsOnLoader || this.state.disableState.awaitingConf} name="examDateOption" value="Future" checked={this.state.data.examDateOption == 'Future'} onChange={this.onInputChange} onBlur={(e) => this.callPartialSave(e, 'examDateOption')}>
                    On a Later Date
                  </Radio>
                </GridCell>              
                <GridCell span="6"/>  
                {examDateComponent} 

                {tempComponent}*/}
              <GridCell span="6">
                <div className="full-width">
                    <div className="mdc-select" role="listbox">
                      <select
                        disabled={this.state.disableState.disableFieldsOnLoader || this.state.disableState.awaitingConf}  
                        name="testcenter"
                        onChange={this.handleTestTrackChange}
                        value={this.state.data.tqTestTrackId}
                        className="mdc-select__native-control two-col-input"
                      >
                        <option value="" selected="">--Select Test Track--</option>
                        {this.state.data.tqTestTracks.map(testTrack => (
                          <option key={testTrack.id} value={testTrack.id} data-name={testTrack.name} track-amount={testTrack.amount}>
                            {testTrack.name} 
                          </option>
                        ))}
                      </select>
                      <label className="mdc-floating-label mdc-floating-label--float-above">Test Track</label>
                      <div className="mdc-line-ripple"></div>
                    </div>
                  </div>
              </GridCell>
              <GridCell span="6"/>
              
              {trackEligbilityComponent}
              {addonOpptionComp}

              <GridCell span="6">
              {listDateComponent}
              <br/>
              {timeSlotComponent}
              <StatusMessage error_msg = {this.state.errorMsg}/>
              </GridCell>

              <GridCell span="12">
                  {partialLoadingComponent}
                </GridCell>

               <GridCell span="6">
                <div>
                  <TextField className='text_input' label="Enter referral code (if any)" autoComplete="off" className="two-col-input" name="referralCode" onChange={this.onInputChange} value={this.state.data.referralCode} disabled={this.state.saveState.saveDisabled}/>
                  <Button onClick={this.handleDiscountApply} disabled={this.state.saveState.saveDisabled}>Apply</Button>
                  <br/>
                  <StatusMessage error_msg = {this.state.formErrors.discountCouponError}/>
                </div>
              </GridCell>
              <GridCell span="6"/>

              <GridCell span="12">
                {regAmountComponent}
                {discountTextComponent}
              </GridCell>

              <GridCell span="6">
                {paymentModeComponent}
              </GridCell>
              <GridCell span = "6"/>
             
              <GridCell span="12">
                <Typography use="subtitle">By clicking on Save/ Save and Pay, I agree to these <a href=" https://mycentacertificationsubmissions.nyc3.digitaloceanspaces.com/TQ_Updated%20T&Cs_11June.pdf " target="_blank">Terms and Conditions.</a></Typography>
              </GridCell>
              {saveButtonComponent}
              </Grid>
              <StatusMessage error_msg = {this.state.errorMsg}/>
              <StatusMessage error_msg = {this.state.formErrors.firstNameError}/>
              <StatusMessage error_msg = {this.state.formErrors.lastNameError}/>
              <StatusMessage error_msg = {this.state.formErrors.emailError}/>
              <StatusMessage error_msg = {this.state.formErrors.emailFormatError}/>
              <StatusMessage error_msg = {this.state.formErrors.dobError}/>
              <StatusMessage error_msg = {this.state.formErrors.phoneNumberError}/>
              <StatusMessage error_msg = {this.state.formErrors.GenderError}/>
              <StatusMessage error_msg = {this.state.formErrors.userNameError}/>  
              <StatusMessage error_msg = {this.state.formErrors.passwordError}/>
              <StatusMessage error_msg = {this.state.formErrors.passwordConfirmationError}/>
              <StatusMessage error_msg = {this.state.formErrors.regPhoneNumberError}/>
              <StatusMessage error_msg = {this.state.formErrors.tqTestTrackError}/>
              <StatusMessage error_msg = {this.state.formErrors.teachingAssociationIdError}/>
              <StatusMessage error_msg = {this.state.formErrors.workingOrganizationError}/>
              <StatusMessage error_msg = {this.state.formErrors.cityOfResidenceError}/>
              <StatusMessage error_msg = {this.state.formErrors.paymentModeError}/>
              <StatusMessage error_msg = {this.state.formErrors.testTrackError}/>
              <StatusMessage error_msg = {this.state.formErrors.testDateError}/>
              <StatusMessage error_msg = {this.state.formErrors.testCenterError}/>
              <StatusMessage error_msg = {this.state.formErrors.examDateOptionError}/>
              <StatusMessage error_msg = {this.state.formErrors.eligibiltyError}/>
              <StatusMessage error_msg = {this.state.formErrors.timeSlotError}/>
            </Card>
          </form>
        </GridCell>
        
      </Grid>  

    )

  }

}

function mapStateToProps() {
  
}

function mapDispatchToProps(dispatch) {
  return {
    userLogin: data => dispatch(actions.userLogin(data)),
    adminLogin: data => dispatch(actions.adminLogin(data)),
  }
} 

export default connect(mapStateToProps, mapDispatchToProps)(CentaTQRegistration);


// WEBPACK FOOTER //
// ./src/views/centa/CentaTQRegistration.jsx